const IconPause = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.5" y="1.5" width="3" height="8" rx="0.5" fill="#D9D9D9" />
      <rect x="6.5" y="1.5" width="3" height="8" rx="0.5" fill="#D9D9D9" />
    </svg>
  );
};

export default IconPause;
